import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FaSave } from 'react-icons/fa';
import { API_BASE } from '../../utils/helpers';

export default function GeneralSettings() {
  const [formData, setFormData] = useState({ min_order_value: '', support_contact: '' });
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState({ type: '', text: '' });

  const fetchSettings = async () => {
    try {
      const res = await axios.get(`${API_BASE}/api/settings/general`);
      if (res.data) setFormData(res.data);
    } catch (error) {
      console.error('Error fetching settings:', error);
      setMsg({ type: 'error', text: 'Failed to load general settings.' });
    }
  };

  useEffect(() => { fetchSettings(); }, []);

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true); setMsg({ type: '', text: '' });
    try {
      await axios.post(`${API_BASE}/api/settings/general`, formData);
      setMsg({ type: 'success', text: 'Settings updated successfully.' });
    } catch (error) {
      console.error('Error saving settings:', error);
      setMsg({ type: 'error', text: 'Failed to save settings.' });
    } finally {
      setSaving(false);
      setTimeout(() => setMsg({ type: '', text: '' }), 3000);
    }
  };

  return (
    <div>
      <div className="mb-6">
        <h2 className="text-lg font-semibold text-slate-900">General Settings</h2>
        <p className="text-sm text-slate-500">Global configuration for the app.</p>
      </div>

      <div className="max-w-2xl">
        {msg.text && (
          <div className={`mb-4 rounded-lg border px-4 py-2.5 text-sm ${
            msg.type === 'success' ? 'border-emerald-200 bg-emerald-50 text-emerald-700' : 'border-rose-200 bg-rose-50 text-rose-700'
          }`}>{msg.text}</div>
        )}

        <form onSubmit={handleSubmit} className="ui-card p-6">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <div>
              <label className="mb-1 block text-sm font-medium text-slate-700">Minimum Order Value (QAR)</label>
              <input className="ui-input" type="number" name="min_order_value" value={formData.min_order_value ?? ''} onChange={handleChange} />
            </div>
            <div>
              <label className="mb-1 block text-sm font-medium text-slate-700">Support Contact Number</label>
              <input className="ui-input" type="text" name="support_contact" value={formData.support_contact ?? ''} onChange={handleChange} />
            </div>
          </div>
          <div className="mt-5">
            <button type="submit" className="ui-btn-primary" disabled={saving}>
              <FaSave className="text-xs" /> {saving ? 'Saving…' : 'Save settings'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
